import React from 'react';
import './Coaches.css';

const Coaches = () => {
    const coachesData = [
        {
            id: 1,
            name: 'Jessica Bare',
            role: 'Head Coach',
            bio: 'Jessica brings a lifelong love of softball and years of experience both on and off the field. A former high school standout who excelled as a catcher and outfielder, Jessica combines her technical knowledge with a deep passion for player development. She began coaching at the local recreational level, where her leadership and ability to connect with young athletes quickly stood out. Her dedication and expertise led to her being recruited as a catching coach—an area where her experience truly shines.\n' +
               'Her coaching philosophy centers on effort, respect, and a genuine love for the sport of softball.',
            imageUrl: '/images/coaches/Jessica_02.jpg',
            focus: 'top'
        },
        {
            id: 2,
            name: 'Katie Comier',
            role: 'Assistant Coach',
            bio: 'Coach Katie brings 4+ years of youth coaching and a lifelong love of the game. A former Little League softball player who also coached Little League baseball, she’s played in adult leagues in San Diego and Charlotte and lives her motto: practice how you play. Known for skill-building, high energy, and hype playlists, she treats every roster like family and can’t wait to help this team grow confident, play smart, and celebrate every win.\n',
            imageUrl: '/images/coaches/Katie.jpg'
        },
        {
            id: 3,
            name: 'Jeremy Kuster',
            role: 'Assistant Coach',
            bio: 'Coach Jeremy has been an assistant coach and a familiar face on the field for several years. He loves working with the girls, helping them grow their skills, and staying connected to the game he enjoys so much. His passion for softball doesn’t stop when coaching ends, when he isn’t on the field with the team, you can usually find him playing in his own adult league! Coach Jeremy brings encouragement, experience, and a love for the game to every practice and game day.\n',
            imageUrl: '/images/coaches/Jeremy.png',
            focus: 'top'
        },
        {
            id: 4,
            name: 'Caleb Johnson',
            role: 'Assistant Coach',
            bio: 'Caleb Johnson has spent the past couple of seasons coaching with Lake Norman Little League, serving as both an assistant coach and, most recently, a head coach. Having grown up playing competitive sports, Caleb understands the dedication, teamwork, and mindset it takes to compete at a high level. He is excited to bring that experience, along with a high level of energy and enthusiasm, to help players build confidence, develop their skills, and foster a lifelong love for the game.\n',
            imageUrl: '/images/coaches/Caleb.png',
            focus: 'top'
        },
        {
            id: 5,
            name: 'Michael Jordan',
            role: 'Assistant Coach',
            bio: 'Coach Michael is 36 years old and has been coaching for 4 years, including 2 years as a head coach. He brings great energy to the field and is known for being loud, positive, and encouraging. Coach Michael enjoys pushing the girls to be their best, helping them grow in confidence, and creating an atmosphere where players feel supported while working hard and having fun.\n',
            imageUrl: '/images/coaches/Michael.jpg',
            focus: 'middle'
        },
    ];

    const getObjectPosition = (focus) => {
        switch (focus) {
            case 'top':
                return 'center top';
            case 'middle':
                return 'center center';
            case 'bottom':
                return 'center bottom';
            default:
                return 'center center';
        }
    };

    return (
        <section className="coaches" id="coaches">
            <div className="container">
                <h2>Our Coaching Staff</h2>
                <div className="coaches-container">
                    {coachesData.map(coach => (
                        <div className="coach-card" key={coach.id}>
                            <div className="coach-image-container">
                                {coach.imageUrl ? (
                                    <img 
                                        src={coach.imageUrl} 
                                        alt={coach.name.split(' ')[0]} 
                                        className="coach-image" 
                                        style={{ objectPosition: getObjectPosition(coach.focus) }}
                                    />
                                ) : (
                                    <div className="coach-image-placeholder">
                    <span className="coach-initials">
                      {coach.name.split(' ').map(n => n[0]).join('')}
                    </span>
                                    </div>
                                )}
                            </div>
                            <div className="coach-info">
                                <h3>{coach.name.split(' ')[0]}</h3>
                                <h4>{coach.role}</h4>
                                <p>{coach.bio}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Coaches;
